// @flow

import updateProjectField from '../Services/updateProjectField';

export default (value: string) => async (dispatch: Function) => {

  dispatch(updateProjectField('notes', value))

}